"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const info_icon_black_svg_1 = __importDefault(require("@@/assets/svgs/info_icon_black.svg"));
const info_icon_orange_svg_1 = __importDefault(require("@@/assets/svgs/info_icon_orange.svg"));
const ClickAwayListener_1 = __importDefault(require("@mui/material/ClickAwayListener"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
function default_1() {
    const [open, setOpen] = (0, react_1.useState)(false);
    const handleClose = () => setOpen(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const descriptions = [
        t('페이폼 수수료가 포함된 금액이며,'),
        `${t('구매자는 판매가로 결제해요')}:)`,
    ];
    return ((0, jsx_runtime_1.jsx)(ClickAwayListener_1.default, Object.assign({ onClickAway: handleClose }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ open: open, placement: "bottom", title: descriptions.map((desc, idx) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { fontSize: '15px', lineHeight: '22px' } }, { children: desc }), `description_${desc.substring(0, 5)}_${idx}`))), arrow: true, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, 
                // ! sx not working properly
                // ? https://github.com/mui/material-ui/issues/28679#issuecomment-949277606
                componentsProps: {
                    tooltip: {
                        sx: {
                            p: '6px 10px',
                            borderRadius: '8px',
                            mt: '8px !important',
                            bgcolor: 'var(--primary-dark)',
                            '.MuiTooltip-arrow': {
                                color: 'var(--primary-dark)',
                            },
                        },
                    },
                } }, { children: (0, jsx_runtime_1.jsxs)(ToggleButton_1.default, Object.assign({ value: "open", selected: open, onClick: () => setOpen(!open), sx: {
                        columnGap: '4px',
                        height: '28px',
                        padding: '0 12px',
                        borderRadius: '100px',
                        border: 0,
                        bgcolor: 'var(--surface-bg) !important',
                        color: 'var(--gray-80)',
                        '&.Mui-selected': { color: 'var(--primary-dark)' },
                    } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1" }, { children: t('수수료 자동계산') })), open ? ((0, jsx_runtime_1.jsx)(info_icon_orange_svg_1.default, { css: { width: '14px', height: '14px', margin: '1px' } })) : ((0, jsx_runtime_1.jsx)(info_icon_black_svg_1.default, { css: { path: { fillOpacity: 0.3 } } }))] })) })) }) })));
}
exports.default = default_1;
